import Axios from '@/plugins/axios';
import { onlineUrl, passportUrl } from '@/utils/config';


// 切换语言
export function changeLanguage(lang) {
  const config = {
    url: `${ onlineUrl }/mk-leads/common/locale/${ lang }`,
    method: 'GET',
    data: {}
  }
  return Axios(config);
}

/**
 * manage-configuration上传图片地址
 */
export function richUpload(params) {
    const config = {
        url: `${ onlineUrl }/seamark/common/attach/rich-text-upload`,
        method: "POST",
        data: params,
        noMessage:true
    };
    return Axios(config);
}

/**
 * manage-configuration paste上传图片地址
 */
export function imgupload(params) {
    const config = {
        url: `${ onlineUrl }/seamark/common/attach/img-upload/external`,
        method: "POST",
        data: params,
        noMessage:true
    };
    return Axios(config);
}

// 获取用户信息
export function getUserInfo() {
  const config = {
    url: `${ passportUrl }/user/login-info`,
    method: 'GET',
    params: {
      t: new Date().getTime()
    }
  }
  return Axios(config);
}